import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/sugarcastle/images/logos/logo.png';

export default function Index() {
  return <Image src={logo} maxW="177px" position="relative" top="0.5" />;
}
